export default {
  title: "Scarica l'app {{app}}",
  qr_code_desc: "Scansiona questo codice QR con il tuo telefono per scaricare l'app",
  cta: "Scarica l'app e accedi per ottenere {{amount}} di cashback!",
  download_from: 'O scarica da:',
  direct_link: 'Link diretto:',
};
